import uuidGenerator from 'uuid/v1'
import React from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/react-hooks'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { CookiesProvider, Cookies } from 'react-cookie'
import { getApolloClient } from '@cred/shared/apollo'
import configureStore from 'utils/redux/configure-store'
import ClientLibrary from 'utils/client'
import ClientInfoService from 'utils/info-service'
import { parse } from 'query-string'
import gtm from '@cred/shared/gtm'
import { createLogger } from '@cred/fe-logger'
import App from 'App'
import config from 'config'
import ApplicationErrorBoundary from 'components/error-boundary'
import 'purecss/build/pure.css' /* Importing Pure here otherwise the import order gets incorrect. */
import 'purecss/build/grids-responsive.css'
import 'iframe-resizer/js/iframeResizer.contentWindow.min.js'
import '@cred/global-assets/styles/common.scss'
import '@cred/global-assets/styles/cred-icon.scss'
import './index.css'

// Initialize client library communication channel
const clientLibrary = new ClientLibrary()

// Initialize client information service
const clientInfoService = new ClientInfoService(clientLibrary)

const cookies = new Cookies()
const apolloClient = getApolloClient(cookies, {
  uri: config.graphqlUri,
  headers: {
    'session-id': uuidGenerator(),
  },
  redirect: url => window.location.href = url,
})

gtm.initialize(config.gtmContainerId, cookies)

createLogger({}, { credibleRoot: config.credibleRoot })

ReactDOM.render(
  <ApplicationErrorBoundary clientInfoService={clientInfoService} clientLibrary={clientLibrary}>
    <ApolloProvider client={apolloClient}>
      <CookiesProvider cookies={cookies}>
        <ReduxProvider store={configureStore({})}>
          <Router basename={config.appRoot}>
            <Route
              path="/:marketplace/:widgetType"
              render={
                ({ location, match }) => (
                  <App
                    clientLibrary={clientLibrary}
                    clientInfoService={clientInfoService}
                    query={parse(location.search)}
                    params={match.params}
                  />
                )
              }
            />
          </Router>
        </ReduxProvider>
      </CookiesProvider>
    </ApolloProvider>
  </ApplicationErrorBoundary>,
  document.getElementById('root'),
)
